import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { GroupsComponent } from './groups.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.SETTINGS.GROUPS' };
var routes = [
    {
        path: 'grupos',
        component: GroupsComponent,
        pathMatch: 'full',
        canActivate: [
            AuthenticatedGuard,
        ],
        data: ɵ0
    }
];
var GroupsModule = /** @class */ (function () {
    function GroupsModule() {
    }
    return GroupsModule;
}());
export { GroupsModule };
export { ɵ0 };
